import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, SearchIcon, FilterIcon, ChevronDownIcon, CheckCircleIcon, AlertCircleIcon, ClockIcon, BarChart2Icon, PieChartIcon, UsersIcon, CalendarIcon, RefreshCwIcon, SlidersIcon, DownloadIcon, XCircleIcon, FileTextIcon, InfoIcon, EyeIcon, PlusIcon } from 'lucide-react';
export function ClaimsReportsPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('active');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  // Mock data for metrics
  const metrics = {
    totalClaims: 152,
    pendingClaims: 37,
    approvedClaims: 98,
    rejectedClaims: 17,
    avgResponseTime: '3.2 days',
    warrantyRate: '64%'
  };
  // Mock data for claims
  const claimsData = [{
    id: '202534704',
    date: 'Jul 7, 2025',
    dealer: 'AGRO+ SRL',
    reportedBy: 'GIULIA OGNIBENE',
    responsible: 'Régis SIMIER',
    type: 'Warranty',
    status: 'Approved',
    isNew: false
  }, {
    id: '202528724',
    date: 'Jun 30, 2025',
    dealer: 'ZEPPELIN',
    reportedBy: 'Grishin Dmitriy',
    responsible: 'Cristina Guillot',
    type: 'Missing part',
    status: 'Requested',
    isNew: true
  }, {
    id: '202523188',
    date: 'Jun 27, 2025',
    dealer: 'YUGAGROPOLIV LLC',
    reportedBy: 'Evgeny Radchenko',
    responsible: 'Evgeny Radchenko',
    type: 'Warranty',
    status: 'Approved',
    isNew: false
  }, {
    id: '202528723',
    date: 'Jun 26, 2025',
    dealer: 'ZEPPELIN',
    reportedBy: 'Grishin Dmitriy',
    responsible: 'Cristina Guillot',
    type: 'Technical issue',
    status: 'Approved',
    isNew: false
  }, {
    id: '202528722',
    date: 'Jun 26, 2025',
    dealer: 'ZEPPELIN',
    reportedBy: 'Grishin Dmitriy',
    responsible: 'Cristina Guillot',
    type: 'Technical issue',
    status: 'Approved',
    isNew: false
  }, {
    id: '202559',
    date: 'Jun 24, 2025',
    dealer: '',
    reportedBy: 'Daniel Fernández',
    responsible: 'Murad Elafsheh',
    type: 'Technical issue by region',
    status: 'Requested',
    isNew: true
  }, {
    id: '202558',
    date: 'Jun 24, 2025',
    dealer: '',
    reportedBy: 'Daniel Fernández',
    responsible: 'Murad Elafsheh',
    type: 'Technical issue by region',
    status: 'Requested',
    isNew: true
  }];
  // Filter claims based on active tab
  const filteredClaims = claimsData.filter(claim => {
    if (activeTab === 'active') {
      return claim.status === 'Requested' || claim.status === 'In Progress';
    } else {
      return claim.status === 'Approved' || claim.status === 'Rejected';
    }
  });
  return <div className="min-h-screen bg-gray-100" data-id="element-7844">
      {/* Header */}
      <div className="bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 text-white" data-id="element-7845">
        <div className="container mx-auto px-6 py-6" data-id="element-7846">
          <div className="flex justify-between items-center" data-id="element-7847">
            <div className="flex items-center" data-id="element-7848">
              <button onClick={() => navigate('/support')} className="mr-3 p-2 hover:bg-blue-900/50 rounded-full transition-colors" data-id="element-7849">
                <ArrowLeftIcon size={20} data-id="element-7850" />
              </button>
              <h1 className="text-2xl font-bold" data-id="element-7851">Claims Reports</h1>
            </div>
            <div className="flex gap-3" data-id="element-7852">
              <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors flex items-center shadow-sm" data-id="element-7853">
                <PlusIcon size={18} className="mr-2" data-id="element-7854" />
                Report New Claim
              </button>
              <button className="px-4 py-2 bg-blue-800/30 hover:bg-blue-800/50 rounded-lg transition-colors flex items-center border border-blue-700/30" data-id="element-7855">
                <DownloadIcon size={18} className="mr-2" data-id="element-7856" />
                Export
              </button>
            </div>
          </div>
          {/* Tabs */}
          <div className="flex mt-6 border-b border-blue-800/50" data-id="element-7857">
            <button className={`px-5 py-3 ${activeTab === 'active' ? 'border-b-2 border-white font-medium' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('active')} data-id="element-7858">
              Active Claims
            </button>
            <button className={`px-5 py-3 ${activeTab === 'closed' ? 'border-b-2 border-white font-medium' : 'text-blue-300 hover:text-white'}`} onClick={() => setActiveTab('closed')} data-id="element-7859">
              Closed Claims
            </button>
          </div>
        </div>
      </div>
      {/* Metrics Panels */}
      <div className="container mx-auto px-6 py-6" data-id="element-7860">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-6" data-id="element-7861">
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7862">
            <div className="flex items-center justify-between mb-3" data-id="element-7863">
              <h3 className="text-gray-500 font-medium" data-id="element-7864">Claims Overview</h3>
              <BarChart2Icon className="text-blue-600" size={20} data-id="element-7865" />
            </div>
            <div className="grid grid-cols-3 gap-2" data-id="element-7866">
              <div className="text-center" data-id="element-7867">
                <div className="text-3xl font-bold text-blue-600" data-id="element-7868">
                  {metrics.totalClaims}
                </div>
                <div className="text-sm text-gray-500" data-id="element-7869">Total</div>
              </div>
              <div className="text-center" data-id="element-7870">
                <div className="text-3xl font-bold text-amber-500" data-id="element-7871">
                  {metrics.pendingClaims}
                </div>
                <div className="text-sm text-gray-500" data-id="element-7872">Pending</div>
              </div>
              <div className="text-center" data-id="element-7873">
                <div className="text-3xl font-bold text-green-500" data-id="element-7874">
                  {metrics.approvedClaims}
                </div>
                <div className="text-sm text-gray-500" data-id="element-7875">Approved</div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7876">
            <div className="flex items-center justify-between mb-3" data-id="element-7877">
              <h3 className="text-gray-500 font-medium" data-id="element-7878">Claim Types</h3>
              <PieChartIcon className="text-indigo-600" size={20} data-id="element-7879" />
            </div>
            <div className="flex items-center justify-center h-16" data-id="element-7880">
              <div className="flex items-center gap-4" data-id="element-7881">
                <div className="flex flex-col items-center" data-id="element-7882">
                  <div className="flex items-center" data-id="element-7883">
                    <div className="w-3 h-3 rounded-full bg-blue-500 mr-1" data-id="element-7884"></div>
                    <span className="text-sm text-gray-600" data-id="element-7885">Warranty</span>
                  </div>
                  <span className="font-bold" data-id="element-7886">{metrics.warrantyRate}</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-7887">
                  <div className="flex items-center" data-id="element-7888">
                    <div className="w-3 h-3 rounded-full bg-amber-500 mr-1" data-id="element-7889"></div>
                    <span className="text-sm text-gray-600" data-id="element-7890">Technical</span>
                  </div>
                  <span className="font-bold" data-id="element-7891">24%</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-7892">
                  <div className="flex items-center" data-id="element-7893">
                    <div className="w-3 h-3 rounded-full bg-green-500 mr-1" data-id="element-7894"></div>
                    <span className="text-sm text-gray-600" data-id="element-7895">Missing</span>
                  </div>
                  <span className="font-bold" data-id="element-7896">12%</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7897">
            <div className="flex items-center justify-between mb-3" data-id="element-7898">
              <h3 className="text-gray-500 font-medium" data-id="element-7899">Response Time</h3>
              <ClockIcon className="text-amber-600" size={20} data-id="element-7900" />
            </div>
            <div className="flex flex-col items-center justify-center h-16" data-id="element-7901">
              <div className="text-3xl font-bold text-amber-600" data-id="element-7902">
                {metrics.avgResponseTime}
              </div>
              <div className="text-sm text-gray-500" data-id="element-7903">Average response time</div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm p-5 border border-gray-200" data-id="element-7904">
            <div className="flex items-center justify-between mb-3" data-id="element-7905">
              <h3 className="text-gray-500 font-medium" data-id="element-7906">Status Distribution</h3>
              <PieChartIcon className="text-green-600" size={20} data-id="element-7907" />
            </div>
            <div className="space-y-3" data-id="element-7908">
              <div data-id="element-7909">
                <div className="flex justify-between text-sm mb-1" data-id="element-7910">
                  <span className="text-gray-600" data-id="element-7911">Approved</span>
                  <span className="font-medium text-gray-800" data-id="element-7912">
                    {metrics.approvedClaims}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-7913">
                  <div className="bg-green-500 h-2 rounded-full" style={{
                  width: `${metrics.approvedClaims / metrics.totalClaims * 100}%`
                }} data-id="element-7914"></div>
                </div>
              </div>
              <div data-id="element-7915">
                <div className="flex justify-between text-sm mb-1" data-id="element-7916">
                  <span className="text-gray-600" data-id="element-7917">Pending</span>
                  <span className="font-medium text-gray-800" data-id="element-7918">
                    {metrics.pendingClaims}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-7919">
                  <div className="bg-amber-500 h-2 rounded-full" style={{
                  width: `${metrics.pendingClaims / metrics.totalClaims * 100}%`
                }} data-id="element-7920"></div>
                </div>
              </div>
              <div data-id="element-7921">
                <div className="flex justify-between text-sm mb-1" data-id="element-7922">
                  <span className="text-gray-600" data-id="element-7923">Rejected</span>
                  <span className="font-medium text-gray-800" data-id="element-7924">
                    {metrics.rejectedClaims}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-7925">
                  <div className="bg-red-500 h-2 rounded-full" style={{
                  width: `${metrics.rejectedClaims / metrics.totalClaims * 100}%`
                }} data-id="element-7926"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Search and Filters */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 mb-6 overflow-hidden" data-id="element-7927">
          <div className="p-5 border-b border-gray-100" data-id="element-7928">
            <div className="flex flex-wrap items-center justify-between gap-4" data-id="element-7929">
              <div className="relative flex-1 min-w-[300px]" data-id="element-7930">
                <input type="text" placeholder="Search by code, reported by or responsible" className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-7931" />
                <SearchIcon className="absolute left-3 top-3 text-gray-400" size={18} data-id="element-7932" />
              </div>
              <div className="flex items-center gap-3" data-id="element-7933">
                <button className="px-3 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors flex items-center" onClick={() => setShowFilters(!showFilters)} data-id="element-7934">
                  <SlidersIcon size={18} className="mr-2" data-id="element-7935" />
                  Filters
                  <ChevronDownIcon size={16} className="ml-1" data-id="element-7936" />
                </button>
                <button className="px-3 py-2 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors flex items-center" data-id="element-7937">
                  <RefreshCwIcon size={16} className="mr-1" data-id="element-7938" />
                  Reset
                </button>
              </div>
            </div>
            {/* Expanded filters */}
            {showFilters && <div className="mt-4 pt-4 border-t border-gray-100 grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-7939">
                <div className="relative" data-id="element-7940">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7941">
                    Status
                  </label>
                  <select className="appearance-none w-full bg-gray-50 px-4 pr-8 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7942">
                    <option data-id="element-7943">All statuses</option>
                    <option data-id="element-7944">Requested</option>
                    <option data-id="element-7945">In Progress</option>
                    <option data-id="element-7946">Approved</option>
                    <option data-id="element-7947">Rejected</option>
                  </select>
                  <ChevronDownIcon className="absolute right-3 bottom-3 text-gray-500" size={16} data-id="element-7948" />
                </div>
                <div className="relative" data-id="element-7949">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7950">
                    Dealer
                  </label>
                  <select className="appearance-none w-full bg-gray-50 px-4 pr-8 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7951">
                    <option data-id="element-7952">All dealers</option>
                    <option data-id="element-7953">AGRO+ SRL</option>
                    <option data-id="element-7954">ZEPPELIN</option>
                    <option data-id="element-7955">YUGAGROPOLIV LLC</option>
                  </select>
                  <ChevronDownIcon className="absolute right-3 bottom-3 text-gray-500" size={16} data-id="element-7956" />
                </div>
                <div className="relative" data-id="element-7957">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7958">
                    Claim Type
                  </label>
                  <select className="appearance-none w-full bg-gray-50 px-4 pr-8 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7959">
                    <option data-id="element-7960">All claim types</option>
                    <option data-id="element-7961">Warranty</option>
                    <option data-id="element-7962">Technical issue</option>
                    <option data-id="element-7963">Missing part</option>
                    <option data-id="element-7964">Technical issue by region</option>
                  </select>
                  <ChevronDownIcon className="absolute right-3 bottom-3 text-gray-500" size={16} data-id="element-7965" />
                </div>
                <div className="relative" data-id="element-7966">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7967">
                    Date Range
                  </label>
                  <input type="date" className="appearance-none w-full bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7968" />
                </div>
                <div className="relative" data-id="element-7969">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7970">
                    Responsible
                  </label>
                  <input type="text" placeholder="Filter by responsible person" className="appearance-none w-full bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7971" />
                </div>
                <div className="relative" data-id="element-7972">
                  <label className="block text-sm text-gray-500 mb-1" data-id="element-7973">
                    Reported By
                  </label>
                  <input type="text" placeholder="Filter by reporter" className="appearance-none w-full bg-gray-50 px-4 py-2 rounded-lg border border-gray-200 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-7974" />
                </div>
              </div>}
          </div>
          {/* Active filters */}
          <div className="px-5 py-3 bg-gray-50 flex flex-wrap items-center gap-2" data-id="element-7975">
            <span className="text-sm text-gray-500 mr-2" data-id="element-7976">Active filters:</span>
            <span className="bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full flex items-center" data-id="element-7977">
              Status: Requested
              <XCircleIcon size={14} className="ml-1 cursor-pointer" data-id="element-7978" />
            </span>
            <span className="bg-blue-100 text-blue-800 text-xs px-3 py-1 rounded-full flex items-center" data-id="element-7979">
              Dealer: ZEPPELIN
              <XCircleIcon size={14} className="ml-1 cursor-pointer" data-id="element-7980" />
            </span>
          </div>
        </div>
        {/* Claims Table */}
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6" data-id="element-7981">
          <div className="overflow-x-auto" data-id="element-7982">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-7983">
              <thead className="bg-gray-50" data-id="element-7984">
                <tr data-id="element-7985">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7986">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7987">
                    Claim
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7988">
                    Dealer
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7989">
                    Reported by
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7990">
                    Responsible
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7991">
                    Claim type
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7992">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-7993">
                {filteredClaims.map(claim => <tr key={claim.id} className="hover:bg-gray-50 transition-colors" data-id="element-7994">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-7995">
                      <div className="flex items-center" data-id="element-7996">
                        {claim.status === 'Approved' ? <CheckCircleIcon size={16} className="text-green-500 mr-2" data-id="element-7997" /> : claim.status === 'Requested' ? <ClockIcon size={16} className="text-amber-500 mr-2" data-id="element-7998" /> : <AlertCircleIcon size={16} className="text-red-500 mr-2" data-id="element-7999" />}
                        <span className={`px-2 py-1 text-xs rounded-full ${claim.status === 'Approved' ? 'bg-green-100 text-green-800' : claim.status === 'Rejected' ? 'bg-red-100 text-red-800' : 'bg-amber-100 text-amber-800'}`} data-id="element-8000">
                          {claim.status}
                        </span>
                      </div>
                      {claim.isNew && <span className="ml-6 mt-1 inline-block px-2 py-0.5 text-xs bg-blue-500 text-white rounded-full" data-id="element-8001">
                          New
                        </span>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-8002">
                      <div className="text-sm font-medium text-gray-900" data-id="element-8003">
                        {claim.id}
                      </div>
                      <div className="text-xs text-gray-500 flex items-center" data-id="element-8004">
                        <CalendarIcon size={12} className="mr-1" data-id="element-8005" />
                        {claim.date}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-8006">
                      {claim.dealer ? <div className="text-sm text-gray-900" data-id="element-8007">
                          {claim.dealer}
                        </div> : <span className="text-xs text-gray-500" data-id="element-8008">—</span>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-8009">
                      {claim.reportedBy}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-8010">
                      {claim.responsible}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-8011">
                      <div className="flex items-center" data-id="element-8012">
                        <span className={`px-2 py-1 text-xs rounded-full ${claim.type === 'Warranty' ? 'bg-blue-100 text-blue-800' : claim.type === 'Missing part' ? 'bg-purple-100 text-purple-800' : 'bg-indigo-100 text-indigo-800'}`} data-id="element-8013">
                          {claim.type}
                        </span>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-8014">
                      <div className="flex items-center justify-end space-x-2" data-id="element-8015">
                        <button className="p-1.5 bg-blue-50 text-blue-600 rounded-lg hover:bg-blue-100 transition-colors" data-id="element-8016">
                          <EyeIcon size={16} data-id="element-8017" />
                        </button>
                        <button className="p-1.5 bg-gray-50 text-gray-600 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8018">
                          <FileTextIcon size={16} data-id="element-8019" />
                        </button>
                        <button className="p-1.5 bg-gray-50 text-gray-600 rounded-lg hover:bg-gray-100 transition-colors" data-id="element-8020">
                          <InfoIcon size={16} data-id="element-8021" />
                        </button>
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
          {filteredClaims.length === 0 && <div className="text-center py-12" data-id="element-8022">
              <div className="mx-auto w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4" data-id="element-8023">
                <FileTextIcon size={24} className="text-gray-400" data-id="element-8024" />
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-1" data-id="element-8025">
                No claims found
              </h3>
              <p className="text-gray-500" data-id="element-8026">
                Try adjusting your filters or search criteria
              </p>
            </div>}
        </div>
        {/* Pagination */}
        <div className="flex items-center justify-between" data-id="element-8027">
          <div className="text-sm text-gray-600" data-id="element-8028">
            Showing <span className="font-medium" data-id="element-8029">1</span> to{' '}
            <span className="font-medium" data-id="element-8030">{filteredClaims.length}</span> of{' '}
            <span className="font-medium" data-id="element-8031">{filteredClaims.length}</span> claims
          </div>
          <div className="flex items-center space-x-2" data-id="element-8032">
            <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-8033">
              Previous
            </button>
            <button className="w-9 h-9 flex items-center justify-center rounded-lg bg-blue-600 text-white font-medium" data-id="element-8034">
              1
            </button>
            <button className="px-3 py-2 border border-gray-300 rounded-lg text-gray-700 bg-white hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-8035">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
}